<div class="content content-with-elevation">
  <div class="basic-details-section">
    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Login Name</label></div>
      <div class="cell large-10 medium-6  small-6 bold-text">{{user.loginName}} </div>
    </div>

    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Email Address</label></div>
      <div class="cell large-8 medium-6  small-6 bold-text">{{user.email}} </div>
    </div>

    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>First Name</label></div>
      <div class="cell large-8 medium-6  small-6 bold-text">{{user.firstName}} </div>
    </div>

    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Last Name</label></div>
      <div class="cell large-8 medium-6  small-6 bold-text">{{user.lastName}} </div>
    </div>
  </div>

  <div *ngIf="isTldManagerProfile()">
    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Place of residence</label></div>
      <div class="cell large-8 medium-6  small-6 bold-text">{{user?.residenceCountryName}} </div>
    </div>

    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Organization</label></div>
      <div class="cell large-8 medium-6  small-6 bold-text">{{user.organizationName}} </div>
    </div>

    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Postal address:</label></div>
      <div class="cell medium-8 large-8 small-6 bold-text">
        {{user?.address?.streetAddress}}
      </div>
    </div>
    <div class="grid-x bold-text">
      <div class="cell large-2 medium-6 small-6"></div>
      <div class="cell medium-8 large-8 small-6">
        <span>
                  {{user?.address?.city}}

        </span>
        &nbsp;<span>
                {{user?.address?.state}}

      </span>
        &nbsp;<span>
                {{user?.address?.postalCode}}
      </span>
      </div>
    </div>
    <div class="grid-x bold-text">
      <div class="cell large-2 medium-6 small-6"></div>
      <div class="cell medium-8 large-8 small-6">
        {{user?.address?.countryName}}

      </div>
    </div>

    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Phone Number</label></div>
      <div class="cell large-8 medium-6  small-6 bold-text">{{user.phone}} </div>
    </div>

    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Mobile Number</label></div>
      <div class="cell large-8 medium-6  small-6 bold-text">{{user.mobile}} </div>
    </div>

    <div class="grid-x">
      <div class="cell large-2 medium-6 small-6"><label>Fax Number</label></div>
      <div class="cell large-8 medium-6  small-6 bold-text">{{user.fax}} </div>
    </div>
    <div class="grid-x last-update-button-section">
      <label>&nbsp;</label>
      <button class="iana-button" (click)="onEdit()" id="update">Modify</button>
    </div>
  </div>
</div>
